import { useEffect, useState } from "react";
import { countPendingOutbox, listFailedOutbox } from "@/domains/offline/outbox/outboxStore";
import { getSyncState, subscribeSyncState, type SyncState } from "@/domains/offline/sync/syncEvents";

export function useSyncStatus(): {
  state: SyncState;
  pendingCount: number;
  failedCount: number;
} {
  const [state, setState] = useState<SyncState>(getSyncState);
  const [pendingCount, setPendingCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);

  useEffect(() => {
    const refreshCounts = async () => {
      setPendingCount(await countPendingOutbox());
      setFailedCount((await listFailedOutbox()).length);
    };
    void refreshCounts();
    return subscribeSyncState((next, detail) => {
      setState(next);
      if (detail?.pendingCount != null) {
setPendingCount(detail.pendingCount);
}
      if (detail?.failedCount != null) {
setFailedCount(detail.failedCount);
}
      void refreshCounts();
    });
  }, []);

  return { state, pendingCount, failedCount };
}
